export const config = {
    backendUrl: process.env.VUE_APP_BACKEND_URL/*'https://workflow.elroble.com/api' */,
    appUrl: process.env.VUE_APP_URL/*'https://workflow.elroble.com/' */,
    ssoUrl: process.env.VUE_APP_SSO_URL/*'https://sso.elroble.com/' */,
    appVersion: "2.5.9",
};
